import { Directive, ElementRef, Input, ContentChild, OnInit, Renderer2, AfterContentInit } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[tiEventsInterceptor]',
})
export class InterceptInvokerDirective implements OnInit, AfterContentInit {
  @Input('tiEventsInterceptor') type: string;

  private typeArray: string[];

  @ContentChild('tiClickTarget', { read: ElementRef }) target: ElementRef;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.typeArray = this.type.split(',').map((el) => el.trim());
  }

  ngAfterContentInit() {
    if (this.target) {
      const el = this.target.nativeElement;
      // TODO: In the latest Kendo UI update: k-dropdown was renamed to k-dropdownlist, k-dropdownlist-wrap was removed
      // const targetEl = el.classList.contains('k-dropdown') ? el.querySelector('.k-dropdown-wrap') : el;
      const targetEl = el.classList.contains('k-dropdownlist') ? el.querySelector('.k-dropdownlist') : el;

      this.typeArray.forEach((type) => {
        this.renderer.listen(this.elementRef.nativeElement, type, (event) => {
          targetEl.click();
        });
      });
    }
  }
}
